import { configurationComponentFace } from '../config/configFace'
import store from '@/store'
import router from '@/router'
import { SELFIE_MESSAGES } from '@/config/selfieMessages'

/**
 * Identifica se a sessão terminou porque o usuário fechou a captura.
 * A checagem é feita pelo nome do status (prefixo UserCancelled) em vez de uma
 * lista fixa, porque o SDK acrescenta variações de cancelamento entre versões.
 * @param {number} status valor de FaceTecSessionStatus
 */
function isUserCancelledStatus(status) {
  // eslint-disable-next-line no-undef
  const statuses = FaceTecSDK.FaceTecSessionStatus

  return Object.keys(statuses).some(
    (name) => statuses[name] === status && name.startsWith('UserCancelled')
  )
}

export class EnrollmentProcessor {
  constructor(sessionToken, client, vueContext, retryFaceCapture, deviceToken) {
    this.success = false
    this.latestSessionResult = null
    this.cancelledDueToNetworkError = false
    this.latestNetworkRequest = new XMLHttpRequest()
    this.nextStep = ''
    this.completeAfterSessionCancel = false
    this.cancelledByUser = false
    this.retry = false
    this.vue = vueContext
    this.retryFaceCapture = retryFaceCapture
    this.deviceToken = deviceToken

    // eslint-disable-next-line no-undef
    const customConfig = configurationComponentFace(FaceTecSDK, client.logo, client)
    // eslint-disable-next-line no-undef
    FaceTecSDK.setCustomization(customConfig)

    // eslint-disable-next-line no-undef
    new FaceTecSDK.FaceTecSession(this, sessionToken)
  }

  async processSessionResultWhileFaceTecSDKWaits(sessionResult, faceScanResultCallback) {
    this.latestSessionResult = sessionResult

    // eslint-disable-next-line no-undef
    if (sessionResult.status !== FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
      this.cancelledByUser = isUserCancelledStatus(sessionResult.status)
      this.latestNetworkRequest.abort()
      faceScanResultCallback.cancel()
      return
    }

    const payload = {
      faceScan: sessionResult.faceScan,
      auditTrailImage: sessionResult.auditTrail[0],
      lowQualityAuditTrailImage: sessionResult.lowQualityAuditTrail[0],
      sessionId: sessionResult.sessionId,
      retryFaceCapture: this.retryFaceCapture,
      deviceToken: this.deviceToken
    }

    try {
      // eslint-disable-next-line no-undef
      const dataValidationFace = await store.dispatch('validSelfieFaceTransaction', { payload, agent: FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId) })
      // return in case of an error
      if (!dataValidationFace.success) {
        console.log('error...')
        if (dataValidationFace.error) {
          this.cancelDueToNetworkError('Falha na validação', faceScanResultCallback)
        } else {
          this.cancelDueToNetworkError('Unexpected API response, cancelling out.', faceScanResultCallback)
        }
      }

      if (dataValidationFace.retry) {
        this.vue.canRetry = true
        this.retry = dataValidationFace.retry
        // Encerra o fluxo atual para o SDK finalizar a sessão e liberar a UI para nova tentativa.
        faceScanResultCallback.cancel()
        return
      }

      if (dataValidationFace.success === true && dataValidationFace.retry === false) {
        this.nextStep = dataValidationFace.nextStep
        this.completeAfterSessionCancel = true
        faceScanResultCallback.cancel()
        return
      }
    } catch (error) {
      console.error('ERROR: ', error)
      this.cancelDueToNetworkError('Unexpected API response, cancelling out.', faceScanResultCallback)
    }
  }

  onFaceTecSDKCompletelyDone() {
    if (this.completeAfterSessionCancel && this.nextStep) {
      // O portal e isento quanto ao resultado da biometria: a conclusao e
      // identica tenha a validacao passado ou nao. Qualquer toast aqui
      // denunciaria o veredito pela presenca ou pela cor. A mensagem do
      // cliente ja aparece na tela de conclusao (text-completed-title).
      router.push({
        name: this.nextStep
      })
      return
    }

    this.success = this.latestSessionResult ? this.latestSessionResult.isCompletelyDone : false

    if (this.success) {
      console.log('Liveness-proven Face Verified')

      router.push({
        name: this.nextStep
      })
    } else if (this.retry) {
      // Uma instrucao por vez: o alerta ja carrega a mensagem e a acao de retentativa.
      this.vue.openRetryAlert()
    } else if (this.cancelledByUser) {
      // Fechar a captura e uma escolha do usuario, nao uma falha:
      // volta para a preparacao sem mensagem de erro.
      this.vue.resetToPreparation()
    } else {
      this.vue.openTerminalAlert(SELFIE_MESSAGES.validationFailure)
    }
  }

  cancelDueToNetworkError(networkErrorMessage = 'error_default', faceScanResultCallback) {
    if (this.cancelledDueToNetworkError === false) {
      console.error(networkErrorMessage)
      this.cancelledDueToNetworkError = true
      faceScanResultCallback.cancel()
    }
  }

  isSuccess() {
    return this.success
  }
}
